import { PHASE_PRODUCTION_BUILD } from "next/constants";
import Footer from "../components/_App/Footer";
import Header from "../components/_App/Header";
import BreadcrumbComponent from "../components/Common/BreadcrumbComponent";
import ExtraPageFooter from "../components/Common/ExtraPageFooter";
import PageHeadingComponent from "../components/Common/PageHeadingComponent";
import SectionsRender from "../components/Common/SectionsRender";
import cacheClient from "../data/cacheClient";
import { PAGE_LIST_QUERY, PAGE_QUERY } from "../data/pageQuery";
import queryWithRetry from "../data/queryWithRetry";

const Page = ({ data, id, seo, menu, footer }) => {
  console.log("datatatatatat", data);
  return (
    <>
      <Header {...menu}></Header>
      <div className='page-wrapper flex-grow-1'>
        <BreadcrumbComponent {...data}></BreadcrumbComponent>
        <div>
          <PageHeadingComponent {...data}></PageHeadingComponent>
          <SectionsRender {...data}></SectionsRender>
        </div>
      </div>
      <ExtraPageFooter></ExtraPageFooter>
      <Footer {...footer}></Footer>
    </>
  );
};

export async function getStaticProps({ params }) {
  const { name, pageIdArray } = params;
  console.log("getStaticProps id", params);
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const country = isAU ? "isAU" : "isNZ";

  let id = "";

  if (Array.isArray(pageIdArray)) {
    if (pageIdArray[0] !== undefined) {
      id = pageIdArray[0];
    }
  }

  if (id === "ryco-nanocel") {
    return {
      redirect: {
        destination: "/air-filters/ryco-nanocel",
        permanent: true,
      },
    };
  }

  var pageDataList, footerContents, menuContents;

  const loadPageFromCms = async () => {
    const filter = `data/pageId/iv eq '${id}'`;
    const { data } = await queryWithRetry({
      query: PAGE_QUERY,
      variables: { filter },
      fetchPolicy: "no-cache",
    });
    return data;
  };

  if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
    //check in local cache written by this build
    let cache = cacheClient();
    let cachePageData = cache.get("pageDataList");
    if (Array.isArray(cachePageData)) {
      footerContents = cache.get("footerContents");
      menuContents = cache.get("menuContents");
      let filterPageData = cachePageData.find((x) => x.flatData?.pageId == id);
      if (filterPageData && footerContents && menuContents) {
        pageDataList = [filterPageData];
      }
    }
    if (!pageDataList) {
      const data = await loadPageFromCms();
      pageDataList = data.queryPagesContents;
      footerContents = data.queryFooterContents;
      menuContents = data.queryMenuContents;
    }
  } else {
    const data = await loadPageFromCms();
    pageDataList = data.queryPagesContents;
    footerContents = data.queryFooterContents;
    menuContents = data.queryMenuContents;
  }

  const notFound = pageDataList?.length == 0;
  const pageData = pageDataList?.length > 0 ? pageDataList[0]?.flatData : {};
  const footerContent =
    footerContents[0] != null ? footerContents[0]?.flatData : [];
  const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

  //console.log("getStaticProps data", pageData);

  pageData.__pageIdArray = pageIdArray;

  const isNzOnly = pageData ? !pageData.isAU && pageData.isNZ : false;
  const url = `/${id}`;

  return {
    props: {
      id: id,
      menu: menuContent,
      footer: footerContent,
      seo: {
        title: pageData.pageTitle,
        metadata: pageData.metaDescription,
        keywords: pageData.keywords ?? null,
        socialTitle: `${pageData.pageTitle}`,
        isNzOnly: isNzOnly,
        url: url,
        extraHeaders: pageData.extraHeaders ?? null,
      },
      data: pageData,
    },
    revalidate: 60 * 1, //1 min
    notFound: notFound,
  };
}

export async function getStaticPaths() {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const country = isAU ? "isAU" : "isNZ";
  const filter = `data/${country}/iv eq true`;

  let pageList = [];
  try {
    const { data } = await queryWithRetry({
      query: PAGE_LIST_QUERY,
      variables: { filter },
    });
    pageList = data.queryPagesContents ?? [];
  } catch (error) {
    console.log(
      "Failed to load page paths. Pages will be generated on request.",
      error
    );
    return {
      paths: [],
      fallback: "blocking",
    };
  }

  const mappedIndex = pageList
    .filter(({ flatData }) => flatData?.pageId && flatData.pageId !== "ryco-nanocel")
    .map(({ id, flatData }) => ({
      params: {
        id: flatData.pageId,
        pageIdArray: [flatData.pageId],
        name: flatData.pageId,
        title: flatData.pageTitle,
        meta: flatData.metaDescription,
        header: flatData.extraHeaders,
        cmsId: id,
      },
    }));

  if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
    // console.log("Loading all page data");
    const cache = cacheClient();
    cache.clear("pageDataList");
    try {
      const dataAll = await queryWithRetry({
        query: PAGE_QUERY,
        variables: { filter: filter },
        fetchPolicy: "network-only",
      });
      const {
        queryPagesContents: pageDataList,
        queryFooterContents: footerContents,
        queryMenuContents: menuContents,
      } = dataAll.data;
      // console.log("Save all page data locally during production build");
      cache.set("footerContents", footerContents);
      cache.set("menuContents", menuContents);
      cache.set("pageDataList", pageDataList);
    } catch (error) {
      console.log(
        "Failed to preload pages. Each page will be loaded individually during the build.",
        error
      );
    }
  }

  return {
    paths: mappedIndex,
    fallback: "blocking",
  };
}

export default Page;
